import type { RegisterParams } from '@common/workflow/serviceActivityRegistry';
import { CustomControlCode } from '@common/enums';
import { noteSections } from '@common/validation/customControls/note';
import { ServiceActivityRegistry } from '@common/workflow/serviceActivityRegistry';
import { addToMdoSections } from '../addToMdo';
import {
    bariatricsExternalReferralDraftSchema,
    bariatricsExternalReferralFinalSchema,
    bariatricsExternalReferralReadSchema,
} from '../bariatrics/bariatricsExternalReferral/v1/bariatricsExternalReferralSchema';
import {
    bariPostCaroWeightMeasurementsDraftSchema,
    bariPostCaroWeightMeasurementsFinalSchema,
    bariPostCaroWeightMeasurementsReadSchema,
} from './bariPostCaroBodyWeightMeasurements/v1/bariPostCaroBodyWeightMeasurementsSchemaV1';
import {
    bariPostCaroBodyWeightMeasurementsInactiveNotificationDraftSchema,
    bariPostCaroBodyWeightMeasurementsInactiveNotificationFinalSchema,
} from './bariPostCaroBodyWeightMeasurementsInactiveNotification/v1/bariPostCaroBodyWeightMeasurementsInactiveNotificationSchemaV1';
import {
    bariPostCaroInactivityReportDraftSchema,
    bariPostCaroInactivityReportFinalSchema,
    bariPostCaroInactivityReportReadSchema,
} from './bariPostCaroInactivityPoliReport/v1/bariPostCaroInactivityPoliReportSchemaV1';
import {
    bariPostCaroQuestionnaireResponseDraftSchema,
    bariPostCaroQuestionnaireResponseFinalSchema,
    bariPostCaroQuestionnaireResponseReadSchema,
} from './bariPostCaroQuestionnaireResponse/v1/bariPostCaroQuestionnaireResponseSchemaV1';
import {
    bariPostCaroQuestionnaireResponsesInactiveNotificationDraftSchema,
    bariPostCaroQuestionnaireResponsesInactiveNotificationFinalSchema,
} from './bariPostCaroQuestionnaireResponsesInactiveNotification/v1/bariPostCaroQuestionnaireResponsesInactiveNotificationSchemaV1';
import {
    bariPostDietConsultReportDraftSchema,
    bariPostDietConsultReportFinalSchema,
    bariPostDietConsultReportReadSchema,
} from './bariPostDietConsultReport/v1/bariPostDietConsultReportSchemaV1';
import {
    bariPostDietitianReportDraftSchema,
    bariPostDietitianReportFinalSchema,
    bariPostDietitianReportReadSchema,
} from './bariPostDietitianReport/v1/bariPostDietitianReportSchemaV1';
import {
    bariPostDietPlanAppointmentDraftSchema,
    bariPostDietPlanAppointmentFinalSchema,
    bariPostDietPlanAppointmentReadSchema,
} from './bariPostDietPlanAppointment/v1/bariPostDietPlanAppointmentSchemaV1';
import './bariPostEnrollment/register';
import {
    bariPostFollowUpWeightMeasurementsDraftSchema,
    bariPostFollowUpWeightMeasurementsFinalSchema,
    bariPostFollowUpWeightMeasurementsReadSchema,
} from './bariPostFollowUpBodyWeightMeasurements/v1/bariPostFollowUpBodyWeightMeasurementsSchemaV1';
import {
    bariPostLifestyleCoachReportDraftSchema,
    bariPostLifestyleCoachReportFinalSchema,
    bariPostLifestyleCoachReportReadSchema,
} from './bariPostLifestyleCoachReport/v1/bariPostLifestyleCoachReportSchemaV1';
import { bariPostMdoReportSections } from './bariPostMdoReport/bariPostMdoReport';
import { bariPostNurseSpecialistFollowUpReadSectionsV1 } from './bariPostNurseSpecialistFollowUp/v1/bariPostNurseSpecialistFollowUpReadSectionsV1';
import {
    bariPostNurseSpecialistFollowUpDraftSchemaV1,
    bariPostNurseSpecialistFollowUpFinalSchemaV1,
} from './bariPostNurseSpecialistFollowUp/v1/bariPostNurseSpecialistFollowUpSchemaV1';
import { bariPostNurseSpecialistFollowUpReadSectionsV2 } from './bariPostNurseSpecialistFollowUp/v2/bariPostNurseSpecialistFollowUpReadSectionsV2';
import {
    bariPostNurseSpecialistFollowUpDraftSchemaV2,
    bariPostNurseSpecialistFollowUpFinalSchemaV2,
} from './bariPostNurseSpecialistFollowUp/v2/bariPostNurseSpecialistFollowUpSchemaV2';
import {
    bariPostNurseSpecialistReportDraftSchema,
    bariPostNurseSpecialistReportFinalSchema,
    bariPostNurseSpecialistReportReadSchema,
} from './bariPostNurseSpecialistReport/v1/bariPostNurseSpecialistReportSchemaV1';
import {
    bariPostPoliReportDraftSchema,
    bariPostPoliReportFinalSchema,
    bariPostPoliReportReadSchema,
} from './bariPostPoliReport/v1/bariPostPoliReportSchemaV1';
import {
    bariPostPsychologistReportDraftSchema,
    bariPostPsychologistReportFinalSchema,
    bariPostPsychologistReportReadSchema,
} from './bariPostPsychologistReport/v1/bariPostPsychologistReportSchemaV1';
import {
    bariPostSecretarialAssistantFollowUpDraftSchema,
    bariPostSecretarialAssistantFollowUpFinalSchema,
    bariPostSecretarialAssistantFollowUpReadSchema,
} from './bariPostSecretarialAssistentFollowUp/v1/bariPostSecretarialAssistentFollowUpSchemaV1';
import { bariPostSurgeryDateSections } from './bariPostSurgeryDate/bariPostSurgeryDate';
import {
    bariPostTreatmentReportDraftSchema,
    bariPostTreatmentReportFinalSchema,
    bariPostTreatmentReportReadSchema,
} from './bariPostTreatmentReport/v1/bariPostTreatmentReportSchemaV1';

const registryElements: RegisterParams[] = [
    {
        customControlCode: CustomControlCode.BariPostAddToMdo,
        sections: addToMdoSections,
        version: 1,
    },
    {
        customControlCode: CustomControlCode.BariPostCaroBodyWeightMeasurements,
        draft: bariPostCaroWeightMeasurementsDraftSchema,
        final: bariPostCaroWeightMeasurementsFinalSchema,
        readSections: bariPostCaroWeightMeasurementsReadSchema,
        version: 1,
    },
    {
        customControlCode: CustomControlCode.BariPostCaroInactivityLifestyleCoachReport,
        draft: bariPostCaroInactivityReportDraftSchema,
        final: bariPostCaroInactivityReportFinalSchema,
        readSections: bariPostCaroInactivityReportReadSchema,
        version: 1,
    },
    {
        customControlCode: CustomControlCode.BariPostCaroInactivityPoliReport,
        draft: bariPostCaroInactivityReportDraftSchema,
        final: bariPostCaroInactivityReportFinalSchema,
        readSections: bariPostCaroInactivityReportReadSchema,
        version: 1,
    },
    {
        customControlCode: CustomControlCode.BariPostCaroInactivitySecretarialAssistantReport,
        draft: bariPostCaroInactivityReportDraftSchema,
        final: bariPostCaroInactivityReportFinalSchema,
        readSections: bariPostCaroInactivityReportReadSchema,
        version: 1,
    },
    {
        customControlCode: CustomControlCode.BariPostCaroBodyWeightMeasurementsInactiveNotification,
        draft: bariPostCaroBodyWeightMeasurementsInactiveNotificationDraftSchema,
        final: bariPostCaroBodyWeightMeasurementsInactiveNotificationFinalSchema,
        version: 1,
    },
    {
        customControlCode: CustomControlCode.BariPostCaroQuestionnaireResponse,
        draft: bariPostCaroQuestionnaireResponseDraftSchema,
        final: bariPostCaroQuestionnaireResponseFinalSchema,
        readSections: bariPostCaroQuestionnaireResponseReadSchema,
        version: 1,
    },
    {
        customControlCode: CustomControlCode.BariPostCaroQuestionnaireResponsesInactiveNotification,
        draft: bariPostCaroQuestionnaireResponsesInactiveNotificationDraftSchema,
        final: bariPostCaroQuestionnaireResponsesInactiveNotificationFinalSchema,
        version: 1,
    },
    {
        customControlCode: CustomControlCode.BariPostDietConsultReport,
        draft: bariPostDietConsultReportDraftSchema,
        final: bariPostDietConsultReportFinalSchema,
        readSections: bariPostDietConsultReportReadSchema,
        version: 1,
    },
    {
        customControlCode: CustomControlCode.BariPostDietitianReport,
        draft: bariPostDietitianReportDraftSchema,
        final: bariPostDietitianReportFinalSchema,
        readSections: bariPostDietitianReportReadSchema,
        version: 1,
    },
    {
        customControlCode: CustomControlCode.BariPostDietPlanAppointment,
        draft: bariPostDietPlanAppointmentDraftSchema,
        final: bariPostDietPlanAppointmentFinalSchema,
        readSections: bariPostDietPlanAppointmentReadSchema,
        version: 1,
    },
    {
        customControlCode: CustomControlCode.BariPostFollowUpBodyWeightMeasurements,
        draft: bariPostFollowUpWeightMeasurementsDraftSchema,
        final: bariPostFollowUpWeightMeasurementsFinalSchema,
        readSections: bariPostFollowUpWeightMeasurementsReadSchema,
        version: 1,
    },
    {
        customControlCode: CustomControlCode.BariPostLifestyleCoachReport,
        draft: bariPostLifestyleCoachReportDraftSchema,
        final: bariPostLifestyleCoachReportFinalSchema,
        readSections: bariPostLifestyleCoachReportReadSchema,
        version: 1,
    },
    {
        customControlCode: CustomControlCode.BariPostMdoReport,
        sections: bariPostMdoReportSections,
        version: 1,
    },
    {
        customControlCode: CustomControlCode.BariPostNote,
        sections: noteSections,
        version: 1,
    },
    {
        customControlCode: CustomControlCode.BariPostNurseSpecialistFollowUp,
        draft: bariPostNurseSpecialistFollowUpDraftSchemaV1,
        final: bariPostNurseSpecialistFollowUpFinalSchemaV1,
        readSections: bariPostNurseSpecialistFollowUpReadSectionsV1,
        version: 1,
    },
    {
        customControlCode: CustomControlCode.BariPostNurseSpecialistReferral,
        draft: bariatricsExternalReferralDraftSchema,
        final: bariatricsExternalReferralFinalSchema,
        readSections: bariatricsExternalReferralReadSchema,
        version: 1,
    },
    {
        customControlCode: CustomControlCode.BariPostNurseSpecialistReport,
        draft: bariPostNurseSpecialistReportDraftSchema,
        final: bariPostNurseSpecialistReportFinalSchema,
        readSections: bariPostNurseSpecialistReportReadSchema,
        version: 1,
    },
    {
        customControlCode: CustomControlCode.BariPostPoliReport,
        draft: bariPostPoliReportDraftSchema,
        final: bariPostPoliReportFinalSchema,
        readSections: bariPostPoliReportReadSchema,
        version: 1,
    },
    {
        customControlCode: CustomControlCode.BariPostPsychologistReport,
        draft: bariPostPsychologistReportDraftSchema,
        final: bariPostPsychologistReportFinalSchema,
        readSections: bariPostPsychologistReportReadSchema,
        version: 1,
    },
    {
        customControlCode: CustomControlCode.BariPostSecretarialAssistentFollowUp,
        draft: bariPostSecretarialAssistantFollowUpDraftSchema,
        final: bariPostSecretarialAssistantFollowUpFinalSchema,
        readSections: bariPostSecretarialAssistantFollowUpReadSchema,
        version: 1,
    },
    {
        customControlCode: CustomControlCode.BariPostSurgeryDate,
        sections: bariPostSurgeryDateSections,
        version: 1,
    },
    {
        customControlCode: CustomControlCode.BariPostTreatmentReport,
        draft: bariPostTreatmentReportDraftSchema,
        final: bariPostTreatmentReportFinalSchema,
        readSections: bariPostTreatmentReportReadSchema,
        version: 1,
    },
    {
        customControlCode: CustomControlCode.BariPostNurseSpecialistFollowUp,
        draft: bariPostNurseSpecialistFollowUpDraftSchemaV2,
        final: bariPostNurseSpecialistFollowUpFinalSchemaV2,
        readSections: bariPostNurseSpecialistFollowUpReadSectionsV2,
        version: 2,
    },
];

ServiceActivityRegistry.instance.registerAll(registryElements);
